// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import initSqlJs from "sql.js";
var fetchArtifactBytes = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, fetch(url, { cache: "no-store" })];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    throw new Error("Unable to load results artifact: HTTP ".concat(response.status));
                }
                _a = Uint8Array.bind;
                return [4 /*yield*/, response.arrayBuffer()];
            case 2: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
        }
    });
}); };
export var loadSqliteDatabase = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var sql, bytes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initSqlJs({
                    locateFile: function (file) { return "/".concat(file); },
                })];
            case 1:
                sql = _a.sent();
                return [4 /*yield*/, fetchArtifactBytes(url)];
            case 2:
                bytes = _a.sent();
                return [2 /*return*/, new sql.Database(bytes)];
        }
    });
}); };
export var queryRows = function (db, sql, params) {
    if (params === void 0) { params = []; }
    var statement = db.prepare(sql, params);
    var rows = [];
    try {
        while (statement.step()) {
            rows.push(statement.getAsObject());
        }
    }
    finally {
        statement.free();
    }
    return rows;
};
var queryTable = function (db, table) {
    try {
        return queryRows(db, "SELECT * FROM ".concat(table));
    }
    catch (error) {
        console.warn("Results SQLite table ".concat(table, " is not available"), error);
        return [];
    }
};
export var readResultsDataset = function (db) { return ({
    election_event: queryTable(db, "election_event"),
    election: queryTable(db, "election"),
    contest: queryTable(db, "contest"),
    candidate: queryTable(db, "candidate"),
    area: queryTable(db, "area"),
    results_event: queryTable(db, "results_event"),
    results_election: queryTable(db, "results_election"),
    results_election_area: queryTable(db, "results_election_area"),
    results_contest: queryTable(db, "results_contest"),
    results_contest_candidate: queryTable(db, "results_contest_candidate"),
    results_area_contest: queryTable(db, "results_area_contest"),
    results_area_contest_candidate: queryTable(db, "results_area_contest_candidate"),
}); };
